import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { DEPRECATED_backwardsCompatibleValues, useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { Button } from "@faire/web--source/slate/Button";
import { Arrow } from "@faire/web--source/slate/icons/foundation/Arrow";
import { Check } from "@faire/web--source/slate/icons/foundation/Check";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
var bannerHeaderText = function(brandName) {
    if (brandName) {
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "j5xyia",
            defaultMessage: [
                {
                    type: 0,
                    value: "Ready to start buying "
                },
                {
                    type: 1,
                    value: "brandName"
                },
                {
                    type: 0,
                    value: " online?"
                }
            ],
            values: DEPRECATED_backwardsCompatibleValues({
                brandName: brandName
            })
        });
    }
    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "tBGzi+",
        defaultMessage: [
            {
                type: 0,
                value: "Ready to start buying wholesale online?"
            }
        ]
    });
};
export var SignUpBanner = /*#__PURE__*/ React.forwardRef(function(props, ref) {
    return /*#__PURE__*/ _jsxs(Container, {
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(Header, {
                color: Core.text.inverse,
                align: "center",
                variant: {
                    mobileAndAbove: "displaySSerifRegular",
                    tabletAndAbove: "displayMSerifRegular"
                },
                children: props.isSpeedDiscover ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "WQRCRM",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Stock your store with Faire"
                        }
                    ]
                }) : bannerHeaderText(props.brandName)
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(Column, {
                children: useValues(props.isSpeedDiscover).map(function(value, index) {
                    return /*#__PURE__*/ _jsxs(React.Fragment, {
                        children: [
                            index === 0 ? null : /*#__PURE__*/ _jsx(Spacer, {
                                height: "2x"
                            }),
                            /*#__PURE__*/ _jsx(Value, {
                                value: value
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(StyledButton, {
                onClick: props.onClick,
                children: /*#__PURE__*/ _jsxs(SignUpButtonContent, {
                    children: [
                        props.isSpeedDiscover ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "3BK5HJ",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Sign up to shop"
                                }
                            ]
                        }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "iVN83N",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Sign Up to Shop"
                                }
                            ]
                        }),
                        /*#__PURE__*/ _jsx(StyledArrowRight, {
                            direction: "right"
                        })
                    ]
                })
            })
        ]
    });
});
var useValues = function(isSpeedDiscover) {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var standardValues = [
        strictLocalize({
            id: "kc42Bd",
            defaultMessage: [
                {
                    type: 0,
                    value: "60-day payment terms"
                }
            ]
        }),
        strictLocalize({
            id: "1LYmcL",
            defaultMessage: [
                {
                    type: 0,
                    value: "Free returns on all opening orders"
                }
            ]
        }),
        strictLocalize({
            id: "DXPfMp",
            defaultMessage: [
                {
                    type: 0,
                    value: "Unique products curated for your store"
                }
            ]
        })
    ];
    var speedDiscoverValues = [
        strictLocalize({
            id: "rvybqA",
            defaultMessage: [
                {
                    type: 0,
                    value: "Products curated just for you"
                }
            ]
        }),
        strictLocalize({
            id: "kc42Bd",
            defaultMessage: [
                {
                    type: 0,
                    value: "60-day payment terms"
                }
            ]
        }),
        strictLocalize({
            id: "1LYmcL",
            defaultMessage: [
                {
                    type: 0,
                    value: "Free returns on all opening orders"
                }
            ]
        })
    ];
    return isSpeedDiscover ? speedDiscoverValues : standardValues;
};
var Container = styled(Column).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-a7674351-0"
})([
    "background-color:",
    ";width:100%;padding:48px 32px 56px;",
    "{padding:56px 0 64px;}"
], Decorative.shade.yellow, responsiveMediaQueries.tabletAndAbove);
var Header = styled(Typography).withConfig({
    componentId: "sc-a7674351-1"
})([
    "max-width:450px;"
]);
var StyledArrowRight = styled(Arrow).withConfig({
    componentId: "sc-a7674351-2"
})([
    "&&{opacity:0;transition:0.5s ease;position:absolute;margin:auto 0;top:0;bottom:0;right:2px;}"
]);
var SignUpButtonContent = styled.span.withConfig({
    componentId: "sc-a7674351-3"
})([
    "transition:0.5s ease;position:relative;"
]);
var StyledButton = styled(Button).withConfig({
    componentId: "sc-a7674351-4"
})([
    "border:0;min-width:228px;width:fit-content;color:",
    ";background-color:white;",
    "{padding:0 10px;}&:focus,&:focus-within{color:",
    ";background-color:white;}&:hover{color:",
    ";background-color:white;",
    "{padding:0 20px 0 0;}",
    "{color:",
    ";opacity:1;right:0;}}"
], Core.text.default, SignUpButtonContent, Core.text.default, Core.text.hover, SignUpButtonContent, StyledArrowRight, Core.text.default);
var StyledRow = styled(Row).withConfig({
    componentId: "sc-a7674351-5"
})([
    "max-width:500px;"
]);
var Value = function(param) {
    var value = param.value;
    return /*#__PURE__*/ _jsxs(StyledRow, {
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(Check, {
                color: Core.icon.inverse
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                color: Core.text.inverse,
                children: value
            })
        ]
    });
};
